import { render, staticRenderFns } from "./ButtonDropdown.vue?vue&type=template&id=64caf35c&scoped=true"
import script from "./ButtonDropdown.vue?vue&type=script&lang=js"
export * from "./ButtonDropdown.vue?vue&type=script&lang=js"
import style0 from "./ButtonDropdown.vue?vue&type=style&index=0&id=64caf35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64caf35c",
  null
  
)

export default component.exports